import { useEffect, useState } from "react";

import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";

import { useMap } from "../contexts/mapContext";
import { useUserAuth } from "../contexts/authContext";

import { getFeaturesFromExternalOperationMessages } from "../manager/operations/opUtil";
import { GetLayer } from "../map/mapUtil";

const useExternalFlightsLayer = (map, visible = true, timerange = null) => {
    const [layerVisible, setLayerVisible] = useState(visible);

    const { externalOperations } = useMap();
    const { userMapSettings } = useUserAuth();

    useEffect(() => {
        setLayerVisible(visible);
    }, [visible]);

    useEffect(() => {
        if (map) {
            handleCreateOrUpdateExistingFlightLayer();
        }
    }, [map, externalOperations, userMapSettings, timerange, layerVisible]);

    const handleCreateOrUpdateExistingFlightLayer = () => {
        const newFeatures = getFeaturesFromExternalOperationMessages(externalOperations, userMapSettings, timerange);

        const layer = GetLayer(map, "externalFlights");
        if (layer) {
            layer.setVisible(layerVisible);
            const source = layer.getSource();

            source.clear();
            source.addFeatures(newFeatures);
        } else {
            const newSource = new VectorSource({
                features: newFeatures
            });
            const newLayer = new VectorLayer({
                source: newSource,
                properties: { name: "externalFlights", selectable: true },
                visible: layerVisible,
                zIndex: 1
            });
            map.addLayer(newLayer);
        }
    };
    const handleToggleExternalFlightsLayer = () => {
        const layer = GetLayer(map, "externalFlights");
        if (!layer) return;

        const prevVisibility = layer.getVisible();
        setLayerVisible(!prevVisibility);
    };

    return [layerVisible, handleToggleExternalFlightsLayer];
};

export default useExternalFlightsLayer;
